import ReactMarkdown from 'react-markdown';

export const MarkdownText = ({ children, testId }) => (
  <div
    data-testid={testId}
    className="text-sm leading-relaxed text-gray-800 dark:text-gray-100 space-y-2
      [&_h1]:text-base [&_h1]:font-semibold [&_h2]:text-base [&_h2]:font-semibold [&_h3]:font-semibold
      [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_li]:my-0.5
      [&_strong]:font-semibold [&_a]:text-teal-700 [&_a]:underline [&_code]:bg-gray-100 [&_code]:px-1 [&_code]:rounded
      dark:[&_code]:bg-slate-700"
  >
    <ReactMarkdown>{children || ''}</ReactMarkdown>
  </div>
);
